function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface104067865"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.450981%,55.29412%,90.980393%)",
      fillOpacity: 1
    },
    d: "M 3.5 6 C 2.960938 5.992188 2.457031 6.277344 2.183594 6.742188 C 1.910156 7.210938 1.910156 7.789062 2.183594 8.257812 C 2.457031 8.722656 2.960938 9.007812 3.5 9 L 6.257812 9 C 6.984375 9 7.589844 9.503906 7.730469 10.21875 L 8.027344 11.78125 L 11.253906 28.71875 C 11.835938 31.773438 14.527344 34 17.636719 34 L 36.363281 34 C 39.472656 34 42.167969 31.773438 42.746094 28.71875 L 45.972656 11.78125 C 46.054688 11.34375 45.941406 10.890625 45.65625 10.542969 C 45.371094 10.199219 44.945312 10 44.5 10 L 10.742188 10 L 10.675781 9.660156 C 10.273438 7.546875 8.40625 6 6.257812 6 Z M 11.3125 13 L 42.6875 13 L 39.800781 28.15625 C 39.484375 29.816406 38.050781 31 36.359375 31 L 17.636719 31 C 15.949219 31 14.515625 29.816406 14.199219 28.15625 L 14.199219 28.152344 Z M 20 36 C 18.34375 36 17 37.34375 17 39 C 17 40.65625 18.34375 42 20 42 C 21.65625 42 23 40.65625 23 39 C 23 37.34375 21.65625 36 20 36 Z M 34 36 C 32.34375 36 31 37.34375 31 39 C 31 40.65625 32.34375 42 34 42 C 35.65625 42 37 40.65625 37 39 C 37 37.34375 35.65625 36 34 36 Z M 34 36 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/emptyCart.64106a499df556bbea0fa6a7f8f678a9.svg";
export { ForwardRef as ReactComponent };